import { NavLink, Outlet } from "react-router-dom";

const Admin = () => {
  return (
    <div className="admin-view">
      <div className="wrapper">
        <div className="admin-nav">
          <NavLink
            to="/admin/users"
            className={({ isActive }) =>
              `nav-section ${isActive ? "active" : ""}`
            }
          >
            Brukere
          </NavLink>
          <NavLink
            to="/admin/sites"
            className={({ isActive }) =>
              `nav-section ${isActive ? "active" : ""}`
            }
          >
            Sites
          </NavLink>
        </div>

        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Admin;
